import React, {useEffect} from "react";
import classNames from "classnames";
import {CInput} from "@coreui/react";
import {useController} from "react-hook-form";
import {MESSAGES_TYPES} from "../../schemes/messages";

const ARInput = ({
                   control,
                   name,
                   trigger,
                   className,
                   pattern,
                   setError,
                   setFormError,
                   patternMismatchMessage,
                   ...props
                 }) => {
  const {
    field: {ref, onChange, ...inputProps},
    fieldState: {invalid, isDirty, error},
    formState: {isSubmitted}
  } = useController({name, control, shouldUnregister: true});

  useEffect(() => {
    setError && setError(error);
  }, [setError, error]);

  const changeHandler = (event) => {
    if (pattern) {
      if (pattern.test(event.target.value)) {
        onChange(event);
        trigger && trigger();
      } else {
        setFormError && setFormError(name, {message: patternMismatchMessage});
      }
    } else {
      onChange(event);
      trigger && trigger();
    }
  };

  return (
    <CInput
      className={classNames("field_right-border-radius", className)}
      innerRef={ref}
      invalid={invalid && error.message.type === MESSAGES_TYPES.DANGER}
      valid={(isDirty || isSubmitted) && !invalid}
      onChange={changeHandler}
      {...inputProps}
      {...props}
    />
  );
};

export default ARInput;